export class SmcError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SmcError';
  }
}

export class OrganisationSelectionError extends SmcError {
  title: string;
  constructor(message: string, title: string) {
    super(message);
    this.name = 'OrganisationSelectionError';
    this.title = title;
  }
}

export class HeurekaConnectionRequiredError extends SmcError {
  title = 'Heureka Verbindung erforderlich';
  constructor() {
    super('Zum Fortfahren ist eine aktive Verbindung zu Ihrem PIS über Heureka Health erforderlich.');
    this.name = 'HeurekaConnectionRequiredError';
  }
}
